function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch(e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class SelectDropdown extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', e => {
      let e_target_closest_option = e.target.closest('.xselect__option');  
      let e_target = e_target_closest_option ? e_target_closest_option : e.target;  

      if (e_target.classList.contains('xselect')) {
        if (e_target.classList.contains('is-opened')) this.close(e_target)
        else this.open(e_target)
      }
      else if (e_target.classList.contains('xselect__option')) {
        this.changeOption(e_target)
      }
      else if (e_target.classList.contains('xselect__options__close') || e_target.classList.contains('xselect__options__background')) {
        this.close(e_target.closest('.xselect'))
      }
    })
    window.addEventListener('keydown', (e) => {
      const openedVariantSelectors = this.querySelectorAll('.is-opened')
      if (e.key === 'Escape' && openedVariantSelectors.length) {
        openedVariantSelectors.forEach(el => this.close(el))
      }
    })
  }

  open(target) {
    if (window.innerWidth <= 1000) {
      document.body.style.overflowY = 'hidden'
    }
    target.classList.add('is-opened')
    this.determineDirection(target)
  }

  close(target) {
    if (window.innerWidth <= 1000) {
      document.body.style.overflowY = ''
    }
    target.classList.remove('is-opened')
  }

  determineDirection(target) {
    if (window.innerWidth <= 1000) return
    const listHeight = target.querySelector('.xselect__options').offsetHeight
    let selectDistanceBottom = window.innerHeight - target.closest('.xselect').getBoundingClientRect().bottom

    // Scroll window to target select position
    if (listHeight > selectDistanceBottom && listHeight && !target.closest('side-drawer')) {
      window.scrollTo({
        top: target.offsetTop
      })
      selectDistanceBottom = window.innerHeight - target.closest('.xselect').getBoundingClientRect().bottom
    }
    
    // If there's still no room for select display it upwards
    if (listHeight > selectDistanceBottom && target.classList.contains('is-opened')) {
      target.classList.add('is-opened--upwards')
    } else {
      target.classList.remove('is-opened--upwards')
    }
  }

  changeOption(target) {
    if (target.hasAttribute('disabled')) {
      this.close(target.closest('.xselect'))
      return
    }

    // Handle visual select 
    const selectedOptions = target.closest('.xselect__options').querySelectorAll('.xselect__option')
    selectedOptions.forEach(option => {
      option.classList.remove('selected')
    })
    target.classList.add('selected')

    // Handle select element
    const currentSelect = target.closest('.xselect').querySelector('select')
    currentSelect.value = target.dataset.option
    // document.dispatchEvent(this.valueChangedEvent)
  }

  updateOptions(selectedValue) {
    const selectedValueLabels = this.querySelectorAll('.xselect__input .xselect__value')
    selectedValueLabels.forEach((target, index) => {
      target.innerHTML = selectedValue.options[index]
    })
  }

}
customElements.define('select-dropdown', SelectDropdown);

class VariantSelector extends SelectDropdown {
  constructor() {
    super();

    this.isDrawer = location.href.includes('/collections/')
    this.getVariantData()
  }

  changeOption(target) {
    const currentSelect = target.closest('.xselect').querySelector('select')
    currentSelect.value = target.dataset.option

    const selectedVariant = this.getVariantId()
    document.querySelector('.product-info__form form input.product-variant-id').value = selectedVariant.id

    // Update URL
    if (!this.isDrawer) window.history.replaceState({ }, '', `${this.dataset.url}?variant=${selectedVariant.id}`);

    // Update product section
    this.renderProductSection(selectedVariant.id, selectedVariant)

    this.updateOptions(selectedVariant)
    this.close(target.closest('.xselect'))

  }

  getVariantId() {
    const selects = this.querySelectorAll('.xselect__select')
    let selected_options = []
    selects.forEach(select => selected_options.push(select.value))

    return this.variantData.filter(variant => selected_options.every(option => variant.option1 == option || variant.option2 == option || variant.option3 == option))[0]
  }

  setLoading(state, productContainer) {
    if (state) productContainer.classList.add('loading-state')
    if (!state) productContainer.classList.remove('loading-state')
  }

  async renderProductSection(variantId, variant) {
    const productContainer = document.querySelector('.product-container')
    this.setLoading(true, productContainer)

    let sectionRenderURL
    if (!this.isDrawer) {
      sectionRenderURL = window.location.pathname + window.location.search + (window.location.search == '' ? '?' : '&') + `sections=${productContainer.id}`
    } else {
      sectionRenderURL = `${window.location.origin}${this.dataset.url}?variant=${variantId}&sections=${productContainer.id}`
    }
    const res = await fetch(sectionRenderURL)
    const section = await res.json()
    
    let sectionHtml = document.createElement('div')
    sectionHtml.innerHTML = section[productContainer.id]
    sectionHtml = sectionHtml.querySelector('.product-container')

    productContainer.innerHTML = sectionHtml.innerHTML
    window.initCarousels() // Reload swiper instances on re-rendered section

    jQuery(".iWishAdd").click(function() {
      var iWishvId = jQuery(this).parents(iwishWrapperClass).find(iWishVarSelector).val();
      iwish_add(jQuery(this), iWishvId);
      document.querySelector('wishlist-counter').update();
      return false;
    });

    if (typeof istockInit !== "undefined") { 
      // Handle Now in stock app...
      istockInit() // Needs to be initialised everytime at least once
      if (!variant.available && document.querySelector('.iStock-wrapper').style.display == 'none') {
        istockInit() // Then initialised again to display element :)))
      }
    }

    this.setLoading(false, productContainer)
  }

  notificationDrawer() {
    document.querySelector('side-drawer').open({
      type: 'backInStock',
    })
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selector', VariantSelector);

class SideDrawer extends HTMLElement {
  constructor() {
    super();
    this.drawer = this.querySelector('.side-drawer__drawer')
    this.drawerContents = this.querySelector('.side-drawer__contents')
    this.addEventListener('click', e => {
      if (e.target.classList.contains('side-drawer__backdrop') || e.target.classList.contains('side-drawer__close')) {
        this.close()
      }
    })
    window.addEventListener('keydown', (e) => {
      if(e.key === 'Escape' && this.classList.contains('is-visible')) {
        this.close()
      }
    })
  }

  open(config) {
    document.body.style.overflowY = 'hidden'
    this.drawerContents.innerHTML = ''
    this.className = ''
    this.classList.add('is-visible')
    if (config.modificator) this.classList.add(config.modificator)
    this.renderContents(config)
  }

  close() {
    document.body.style.overflowY = ''
    this.drawerContents.innerHTML = ''
    this.className = ''
  }

  setLoading(isLoading) {
    if (isLoading) this.drawer.classList.add('loading-state')
    else this.drawer.classList.remove('loading-state')
  }

  async renderContents(config) {

    const sections = {
      quickView: 'main-product',
      productAdded: 'drawer-product-added',
      backInStock: 'drawer-back-in-stock',
    }

    this.setLoading(true)

    let sectionRenderURL = null
    if (config.type === 'quickView' || config.type === 'productAdded') {
      switch (config.type) {
        case 'quickView':
          sectionRenderURL = `/products/${ config.handle }?sections=${ sections[config.type] }`
          break

        case 'productAdded':
          sectionRenderURL = `${ window.Shopify.routes.root }recommendations/products?product_id=${ config.product_id }&limit=8&section_id=${ sections[config.type] }&intent=related&variant_id=${ config.variant_id }`
          break
      }

      try {
        const res = await fetch(sectionRenderURL)
        const parser = new DOMParser()
        let section

        if (config.type === 'productAdded') {
          const markup = await res.text()
          section = parser.parseFromString(markup, 'text/html')
          
        } else {
          const markup = await res.json()
          section = parser.parseFromString(Object.values(markup)[0], 'text/html')
        }
        
        this.drawerContents.innerHTML = section.querySelector('.shopify-section').innerHTML
        

        if (config.type == 'quickView') {
          const main_carousel = {
            class: ".side-drawer__contents .main-product__main-carousel",
            config: {
              a11y: {
                containerMessage: 'Main gallery slider',
                prevSlideMessage: 'Previous slide',
                nextSlideMessage: 'Next slide',
              },
              allowTouchMove: true,
              autoHeight: true,
              keyboard: {
                enabled: true,
                onlyInViewport: false,
              },
              loop: true,
              slidesPerView: 1,
              spaceBetween: 32,
              navigation: {
                nextEl: '.main-product__main-carousel__btn--next',
                prevEl: '.main-product__main-carousel__btn--prev'
              },
              pagination: {
                el: ".main-product__main-carousel__pagination",
              },
              on: {
                click: (swiper, event) => {
                  if (window.innerWidth < 999) return
                  window.carousels["product-lightbox"].slideTo(swiper.clickedIndex)
                  document.querySelector('product-lightbox').show()
                }
              },
              threshold: 10,
            }
          }
          window.swiperInstances = window.swiperInstances ? { ...swiperInstances, main_carousel} : { main_carousel }
          window.initCarousels()
        } else if (config.type === 'productAdded') {
          let drawer_remove_button = document.querySelector('.drawer-product-added__product .btn:not(.event_is_set)');
          if (drawer_remove_button) {
            drawer_remove_button.addEventListener('click', () => {

              let id = parseFloat(drawer_remove_button.closest('.drawer-product-added__product').getAttribute('data-product-id')),
                  formData = new FormData();

              drawer_remove_button.closest('.drawer-product-added').classList.add('removal_in_progress');
              formData.append(`updates[${id}]`, 0);
              fetch(window.Shopify.routes.root + 'cart/update.js', {
                method: 'POST',
                body: formData
              })
              .then(response => response.json())
              .then(() => {
                drawer_remove_button.closest('.drawer-product-added').classList.add('product_removed');
              })

            });
          }
        }
        this.setLoading(false)
      } catch(e) {
        console.error(e)
        this.setLoading(false)
      }
    } else if (config.type === "backInStock") {
      // TODO
      const notifyMeText = (window.productStrings && window.productStrings.notifyMe) ? window.productStrings.notifyMe : "Notify me";
      this.drawerContents.innerHTML = notifyMeText
      this.setLoading(false)
    }

  }
}

customElements.define('side-drawer', SideDrawer);

class BuyButtons extends HTMLElement {
  constructor() {
    super();

    this.isDrawer = this.closest("side-drawer") ? true : false;
    this.produtForm = this.closest('form')
    this.buyButton = this.querySelector('button[type="submit"]');

    this.buyButton.addEventListener('click', e => {
      this.addToCart(e)
    })
  }

  addToCart(e) {
    e.preventDefault()
    this.isDrawer ? this.closest(".side-drawer__drawer").classList.add('loading-state') : e.target.classList.add('is-loading')
    const data = new FormData(this.produtForm)
    const currentVariantId = document.querySelector('.product-variant-id').value

    let e_form = e.target.closest('form'),
        e_color_pattern = e_form.querySelector('[name="properties[Kolor/Wzór]"]') ? e_form.querySelector('[name="properties[Kolor/Wzór]"]') : false; 
    
    let atcUrl, cartData
    if (this.dataset.action == "update") {
      atcUrl =  'cart/change.js'
      cartData = {
        id: this.dataset.lineKey,
        quantity: Number(this.buyButton.dataset.qty) + 1
      }
    } else {
      atcUrl =  'cart/add.js'
      cartData = {
        items: [{
          id: Number(data.get('id')),
          quantity: 1,
        }]
      }
    }

    if (e_color_pattern) {
      if (cartData.items) {
        cartData.items[0].properties = {
          'Kolor/Wzór': e_color_pattern.value
        };
      } else {
        cartData.properties = {
          'Kolor/Wzór': e_color_pattern.value
        };
      }
    }

    fetch(window.Shopify.routes.root + atcUrl, {
        method: 'POST',
        body: JSON.stringify(cartData),
        headers: {
          'Content-Type': 'application/json'
        }
    })
    .then(response => response.json()).then(data => {
      let addedItem
      if (String(data.status)[0] == '4' || String(data.status)[0] == '5') {
        if (data.status == 422) {
          e.target.disabled = true
          this.querySelector('.atc-error').textContent = data.message
        }
        this.querySelector('.atc-error').classList.add('is-visible')
        return 
      }

      if (data.token) {
        addedItem = data.items.filter(item => item.variant_id == currentVariantId)[0]
        document.querySelector('cart-counter')?.set(data.item_count)
        document.querySelector('cart-counter-mobile')?.set(data.item_count)
      } else {
        addedItem = data.items[0]
        document.querySelector('cart-counter')?.plus(1)
        document.querySelector('cart-counter-mobile')?.plus(1)
      }

      this.buyButton.querySelector('span').innerHTML = `<span class="buy-buttons__qty">${addedItem.quantity}</span> ${this.buyButton.dataset.added}`
      this.buyButton.dataset.qty = addedItem.quantity

      document.querySelector('side-drawer').open({
        modificator: 'side-drawer--product-added',
        type: 'productAdded',
        product_id: addedItem.product_id,
        variant_id: addedItem.id,
        addedItem
      })

    })
    .finally(() => {
      this.isDrawer ? this.closest(".side-drawer__drawer")?.classList.remove('loading-state') : e.target.classList.remove('is-loading')
    })
  }
}

customElements.define('buy-buttons', BuyButtons);

class QuickView extends HTMLElement {
  constructor() {
    super();
    this.drawer = document.querySelector('side-drawer')
    if (this.drawer) {
      this.addEventListener('click', e => {
        e.preventDefault()
        this.quickAdd()
      })
    } else {
      this.remove()
    }
  }

  quickAdd() {
    this.drawer.open({
      modificator: 'side-drawer--quick-view',
      type: 'quickView',
      handle: this.dataset.handle
    })
  }
}

customElements.define('quick-view', QuickView);

class ProductCardVariants extends HTMLElement {
  constructor() {
    super();
    
    this.productCard = this.closest('.product-card');
    this.productLink = this.productCard.querySelector('a');
    this.productLinkHref = this.productLink.getAttribute('href');

    // console.log('productLink', this.productLink);

    if (window.innerWidth < 767) {
      this.productLink.addEventListener('click', e => {
        e.preventDefault();
        this.classList.add('active');
        this.handleMobileHoverTrigger();
      });
    }
  }

  handleMobileHoverTrigger() {
    if (this.productCard.classList.contains('product-card--trigger-hover')) {
      window.location.replace(this.productLinkHref);
    }
    this.productCard.classList.add('product-card--trigger-hover');    
  }
}

customElements.define('product-card-variants', ProductCardVariants);